import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

export enum ProfileMenuSize {
    Regular,
    Condensed,
}

interface ProfileMenuOptionProps {
    visible?: boolean;
    onClick: () => void;
    children: any;
    icon: IconDefinition;
    menuSize?: ProfileMenuSize;
}

export const ProfileMenuOption: React.FC<ProfileMenuOptionProps> = ({
    visible = true,
    onClick,
    children,
    icon,
    menuSize = ProfileMenuSize.Regular,
}) => {
    const styles = {
        condensedMenu: {
            fontSize: '14px',
        },
    };

    return (
        <>
            {visible && (
                <li>
                    <a
                        onClick={onClick}
                        style={menuSize == ProfileMenuSize.Condensed ? styles.condensedMenu : {}}
                    >
                        <FontAwesomeIcon
                            icon={icon}
                            style={{ paddingRight: '10px' }}
                        />
                        {children}
                    </a>
                </li>
            )}
        </>
    );
};
